/* BC Hero video: hold the poster still, then cross-fade into motion.

   Deliberately robust, because muted-autoplay has several failure modes:
   - <source media="..."> is unreliable for video, so the source is picked here.
   - Some browsers need the muted PROPERTY set, not just the attribute.
   - iOS Low Power Mode and Safari refuse play() outright; in that case we
     retry once on the visitor's first interaction rather than silently
     leaving a static image.

   Note: prefers-reduced-motion is intentionally NOT honoured here, at the
   client's explicit request, so the hero plays for every visitor. The
   motion is a muted, looping background with no flashing, which is the
   mildest category of the thing that preference guards against.

   The delay timer only arms once the hero is on screen, so a visitor who
   lands further down the page does not download the video. */
(function () {
  var MOBILE_MAX = 749;

  function reveal(video) {
    video.classList.add('is-playing');
    video.style.opacity = '1';
  }

  function chooseSource(video) {
    var desktop = video.dataset.bcSrcDesktop;
    var mobile = video.dataset.bcSrcMobile;
    var wanted = window.innerWidth <= MOBILE_MAX && mobile ? mobile : desktop;
    if (!wanted) return false;
    // Compare against the resolved URL so we do not reload the same file.
    if (video.currentSrc !== wanted && video.getAttribute('src') !== wanted) {
      video.setAttribute('src', wanted);
      video.load();
    }
    return true;
  }

  function initVideo(video) {
    if (video.dataset.bcInit === '1') return;
    video.dataset.bcInit = '1';

    var delay = parseFloat(video.dataset.bcDelay);
    if (isNaN(delay) || delay < 0) delay = 5;

    if (!chooseSource(video)) return;

    var started = false;
    var retryBound = false;

    function bindRetry() {
      if (retryBound) return;
      retryBound = true;
      var events = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'];
      var onInteract = function () {
        events.forEach(function (e) {
          window.removeEventListener(e, onInteract);
        });
        attempt();
      };
      events.forEach(function (e) {
        window.addEventListener(e, onInteract, { once: true, passive: true });
      });
    }

    function attempt() {
      // Muted must be true at the moment play() is called.
      video.muted = true;
      video.defaultMuted = true;
      var p;
      try {
        p = video.play();
      } catch (err) {
        bindRetry();
        return;
      }
      if (p && typeof p.then === 'function') {
        p.then(function () {
          started = true;
          reveal(video);
        }).catch(function () {
          // Blocked (Low Power Mode, strict policy). Try again on first input.
          bindRetry();
        });
      } else {
        started = true;
        reveal(video);
      }
    }

    function start() {
      if (started) return;
      if (video.readyState >= 2) {
        attempt();
      } else {
        // Not buffered yet: play as soon as it can render a frame.
        video.addEventListener('loadeddata', attempt, { once: true });
        attempt(); // most browsers cope with an early call
      }
    }

    var timer = null;

    function arm() {
      if (timer || started) return;
      timer = setTimeout(start, delay * 1000);
    }

    function disarm() {
      if (timer && !started) {
        clearTimeout(timer);
        timer = null;
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) arm();
            else disarm();
          });
        },
        { threshold: 0.2 }
      );
      io.observe(video);
    } else {
      arm();
    }
  }

  function init() {
    document.querySelectorAll('.bc-hero__video[data-bc-delay]').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
